module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie H3 is a html <code>&lt;h3&gt;</code> text element</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;H3&gt;Your title goes here&lt;/H3&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/H3/README.md
// module id = 354
// module chunks = 0